import { api } from '@fno/service/global.js'

export const getArenas = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}/arenas`)
    .then(response => response.data)

export const patchArena = ({ arena }) => api
    .patch(`/v2/schools/${arena.meta.schoolId}/arenas/${arena.id}`, { data: arena })
    .then(response => response.data)

export const createArena = ({ arena }) => api
    .post(`/v2/schools/${arena.meta.schoolId}/arenas`, { data: arena })
    .then(response => response.data)

